



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiPermissions } from '@/core/security/Permissions';
import { ModalConstants } from '@/core/constants';
import { AdminApi } from '@/services/api/api.admin';
import { AccountViewObject, UpdateIngameAccountPasswordRequest } from '@/types/apiServerContract';

@Component
export default class EditIngamePassword extends Vue {
	@Prop({ required: true }) account!: AccountViewObject;

	id: string = ModalConstants.ChangeIngamePassword;
	permissions: string[] = [ApiPermissions.User.EditIngameAccountPassword];

	password: string = '';
	passwordConfirm: string = '';
	loading: boolean = false;

	ChangePassword() {
	    this.loading = true;

	    const request: UpdateIngameAccountPasswordRequest = {
	        userId: this.account.id,
	        password: this.password
	    };

	    AdminApi.UpdateIngameAccountPassword(request)
	        .then(result => {
	            this.$bvModal.hide(this.id);
	            this.$bvToast.toast(`${this.account.username}'s password has been changed successfully`, {
	                variant: 'success',
	                title: 'Success'
	            });
	        })
	        .finally(() => (this.loading = false));
	}

	Reset() {
	    this.password = '';
	    this.passwordConfirm = '';
	    this.$nextTick(() => {
	        (this.$refs.Validator as any).reset();
	    });
	}
}
